$(document).ready(function() {
  var model = $('#model').val();
  var dataToSend = {
    'model' : model,
    'shop' : 'https://tvsparts-indonesia.myshopify.com'
  }
  $.ajax({
      url: 'https://apim.tvsmotor.com/sea/id/ecomapi/api/advanced-search-filter', // Your app's endpoint
      type: 'post',
      contentType: 'application/json', // Specify that the request is sending JSON
      data: JSON.stringify(dataToSend), // Send the data as a JSON string
      header : {
           'Access-Control-Allow-Origin':'https://tvsparts-indonesia.myshopify.com/',
          //'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods':'GET,POST'
        },
          success: function(response) {
        var model = response.model;
        var part = response.part;
        var series = response.series;
        var group_part = response.group_part;
        if(model) {
          var modelHtml = '<option value="" disabled="" selected="">Select Model</option>';
          for (let i = 0; i < model.length; i++) {
            if(model[i]!=null) var modelHtml = modelHtml + '<option value="'+model[i]+'">'+model[i]+'</option>';
          }
          $('#model').append(modelHtml);
        }
      
        if (series && series.length > 0) {
          var seriesHtml = '<option value="' + series[0] + '" selected>' + series[0] + '</option>';
          for (let i = 1; i < series.length; i++) {
            seriesHtml += '<option value="' + series[i] + '">' + series[i] + '</option>';
          }
          $('#series').append(seriesHtml);
        }
        
        if (group_part && group_part.length > 0) {
          var group_partHtml = '<option value="' + group_part[0] + '" selected>' + group_part[0] + '</option>';
          for (let i = 1; i < group_part.length; i++) {
            group_partHtml += '<option value="' + group_part[i] + '">' + group_part[i] + '</option>';
          }
          $('#partCategoryGroup').append(group_partHtml);
        }
      },
      error: function(error) {
        console.log('Error:', error);
      }
  });

  $('#model').on('change',function() {
    var modelsel = $('#model').val();
    var dataToSend = {
      'model' : modelsel
    }
    console.log("model sel ",modelsel);
    $.ajax({
      url: 'https://apim.tvsmotor.com/sea/id/ecomapi/api/advanced-search-filter', // Your app's endpoint
      type: 'post',
      contentType: 'application/json', // Specify that the request is sending JSON
      data: JSON.stringify(dataToSend), // Send the data as a JSON string
      header : {
           'Access-Control-Allow-Origin':'https://tvsparts-indonesia.myshopify.com/',
          // 'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods':'GET,POST'
        },
      success: function(response) {
        console.log("response -----", response);
        var model = response.model;
        var part = response.part;
        var series = response.series;
        var group_part = response.group_part;
        if(model) {
          console.log("model g",modelsel,model)
          $('#model').empty();
          var modelHtml = '<option value="" disabled="" >Select Model</option>';
          for (let i = 0; i < model.length; i++) {
          

             if (model[i] != null) {
    var selectedAttribute = (modelsel == model[i]) ? ' selected' : '';
    modelHtml += '<option value="' + model[i] + '"' + selectedAttribute + '>' + model[i] + '</option>';
  }
          }
          $('#model').append(modelHtml);
        }
        if(series) {
          $('#series').empty();
          var seriesHtml = '<option value="' + series[0] + '" selected>' + series[0] + '</option>';
          for (let i = 1; i < series.length; i++) {
            seriesHtml += '<option value="' + series[i] + '">' + series[i] + '</option>';
          }
          $('#series').append(seriesHtml);
        }
        if(group_part) {
          $('#partCategoryGroup').empty();
          var group_partHtml = '<option value="' + group_part[0] + '" selected>' + group_part[0] + '</option>';
          for (let i = 1; i < group_part.length; i++) {
            group_partHtml += '<option value="' + group_part[i] + '">' + group_part[i] + '</option>';
          }
          $('#partCategoryGroup').append(group_partHtml);
        }
      },
      error: function(error) {
        console.log('Error:', error);
      }
    });
  });

  $('.eye-button').on('click',function(){
    var eyeSelector = $(this).parent().closest('li');
    var productId = eyeSelector.find( "div" ).attr('data-product-id');
    var dataToSend = {
      'product_id':productId,
      'shop':'https://tvsparts-indonesia.myshopify.com/'
    }
    $.ajax({
      url: 'https://apim.tvsmotor.com/sea/id/ecomapi/api/custom-parts', // Your app's endpoint
      type: 'post',
      contentType: 'application/json', // Specify that the request is sending JSON
      data: JSON.stringify(dataToSend), // Send the data as a JSON string
      header : {
           'Access-Control-Allow-Origin':'https://tvsparts-indonesia.myshopify.com/',
          // 'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods':'GET,POST'
        },
      success: function(response) {
        $('.iamge-component').remove();
        console.log("response",response)
        var image = response.image;
        var src = image.src;
        // Hide the default featured image
        const screenWidth = window.innerWidth;
        if(screenWidth < 768){
          $('.img-featured-for-customparts.slick-initialized.slick-slider.slick-dotted').css('display', 'none');
        
          // Insert the new image component before the .custom_parts_product_list_heading_wrapper element
          // Create the popup overlay and content
          $('.custom_parts_product_list_heading_wrapper').before(`
            <div class="popup-overlay">
              <div class="iamge-component part-image pop-up-mobile">
                <button class="close-btn custom-parts-closebtn" aria-label="Close">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="close-icon">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
                <img id="custom-part-replaced-secondary-img" src="${src}" height="100%" width="100%">
              </div>
            </div>
          `);
          
          $('body').css('overflow', 'hidden');

          // Close the popup when the close button is clicked
          $('.custom-parts-closebtn').on('click', function() {
            $('.popup-overlay').remove();
            // Re-enable scrolling on body when popup is closed
            $('body').css('overflow', 'auto');
          });
        } else {
          $('.img-featured-for-customparts.slick-initialized.slick-slider.slick-dotted').css('display', 'none');
        
          // Insert the new image component before the .custom_parts_product_list_heading_wrapper element
          $('.custom_parts_product_list_heading_wrapper').before('<div class="iamge-component part-image"><button class="close-btn custom-parts-closebtn" aria-label="Close"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="close-icon"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button><img id="custom-part-replaced-secondary-img" src="' + src + '" height="100%" width="100%"></div>');
          
          // Close button functionality
          $('.close-btn.custom-parts-closebtn').on('click', function() {
              // Toggle the display of the elements
              $('.img-featured-for-customparts.slick-initialized.slick-slider.slick-dotted').css('display', 'block');
              $('.iamge-component').css('display', 'none');
          });
        }
        
        
      
      },
      error: function(error) {
        console.log('Error:', error);
      

      }
    });
  });

  $('.custom_collection_titile_wrapper').on('click',function() {
    var tab_selector = $('.tab-content.active');
    var selector = $('.collection-list-wrapper.tabs_collectionsss');
    var ul_selector = tab_selector.find('li.cards_item').first();
    var anchor = ul_selector.find('a.custom_parts_sub_collection_pdpList');
    if (anchor.length) {
        anchor.trigger("click");
    } else {
        console.warn("No anchor tag found.");
    }
  });

  $('#advanced_searchForm').on('submit',function(event){
    event.preventDefault();
    
  var model = $('#model').val();
  var series = $('#series').val();
  var partCategoryGroup = $('#partCategoryGroup').val();
  var partNumber = $('#partNumber').val().trim();
  var partDescription = $('#partDescription').val().trim();

  // Check if all fields are empty
  if (!model ) {
    showToast('Please select Model');
    return;
  }
    var dataToSend = {
      'model' : $('#model').val(),
      'series' : $('#series').val(),
      'partCategoryGroup' : $('#partCategoryGroup').val(),
      'partNumber' : $('#partNumber').val(),
      'partDescription' : $('#partDescription').val(),
      'shop' : 'https://tvsparts-indonesia.myshopify.com/'
    };
    console.log(dataToSend);
    
    $.ajax({
      url: 'https://apim.tvsmotor.com/sea/id/ecomapi/api/advanced-search', // Your app's endpoint
      type: 'post',
      showLoader: true,
      contentType: 'application/json', // Specify that the request is sending JSON
      data: JSON.stringify(dataToSend), // Send the data as a JSON string
      header : {
           'Access-Control-Allow-Origin':'https://tvsparts-indonesia.myshopify.com/',
          // 'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods':'GET,POST'
        },
      success: function(response) {
        $('body').trigger('processStop');
        console.log('response:', response);
          // Save the response in local storage
          localStorage.setItem('searchResults', JSON.stringify(response.products));
          console.log('checking locat setup', JSON.stringify(response.products));
          console.log(response.products)
          window.location.href = '/search'; // Replace with your actual search page URL
      },
      error: function(error) {
        console.log('Error:', error);
      }
  });
  });
 
 function showToast(message) {
  const toast = $('#advanced-search-toast');
  toast.text(message).stop(true, true).fadeIn(300);

  setTimeout(() => {
    toast.fadeOut(500);
  }, 1500);
}
  // Add click event to the image container
  $('.image-container').on('click', function() {
    // You can add your desired functionality here
    console.log('Image container clicked!');
    
    // For example, you might want to open a modal, 
    // trigger a specific action, or highlight categories
    
    // If you want to toggle or select a default category
    $('#partCategoryGroup option:first-child').prop('selected', true);
    $('#partCategoryGroup').trigger('change');
  });
  
})

// product page toggle js

      function toggleOffers(offerListId) {
        const offerList = document.getElementById(offerListId);
        if (offerList.style.display === "none" || offerList.style.display === "") {
          offerList.style.display = "block";
        } else {
          offerList.style.display = "none";
        }
      }
  
  
      let isExpanded = false;
    
      function toggleOfferVisibility() {
        const offerContainers = document.querySelectorAll('.availble_offer_second_wrapper .offer-container:nth-child(n+3)');
        
        if (isExpanded) {
          // Hide all except the first two offer-containers
          offerContainers.forEach(container => container.style.display = 'none');
        } else {
          // Show all offer-containers
          offerContainers.forEach(container => container.style.display = 'block');
        }
        isExpanded = !isExpanded; // Toggle the state
      } 
   
//clear the input of search 
$('.btn--close-search').on('click', function () {
  $('#Search.search__input').val('');
});





